import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type SectionConversationStore } from 'pages/conversations/pages/search/pages/profile/ui/SectionConversation'

export const SectionConversationContext = createContext<SectionConversationStore | null>(null)

export const useSectionConversationContext = () => {
  const context = useContext(SectionConversationContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with SectionConversationContext'
    )

  return context
}

type IProviderSectionConversationProps = {
  value: SectionConversationStore
  children: ReactNode
}

export const ProviderSectionConversation: FC<IProviderSectionConversationProps> = ({
  value,
  children,
}) => {
  return (
    <SectionConversationContext.Provider value={value}>
      {children}
    </SectionConversationContext.Provider>
  )
}
